import { API_REFERENCE } from '../utilities/constant_api';
import { htmlGet } from '../components/ajax';

const selectedOrdercheck = document.getElementsByClassName('selectedOrder');
const selectedOrderRowcheck = document.getElementsByClassName(
  'selectedOrderRow'
);
const selectedOrderRowClass = '.selectedOrderRow';
const returnedOrderClass = '.returnedOrder';
const orderHistoryReturnExchangeClass = '.orderHistory-returnExchange';
const returnedOrdereClass = '.returnedOrder';
$(document).delegate('.return-exchange', 'click', function() {
  const targetUrl = ACC.config.encodedContextPath + '/my-account-home/returns';
  window.location.replace(targetUrl);
  $('#TrackOrder')
    .addClass('nav-active-class')
    .siblings('.nav-active-class')
    .removeClass('nav-active-class');
});

function updatePaginationData(pageValue) {
  const targetUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.returns.returnsPagination}?page=${pageValue}`;
  htmlGet(targetUrl).then(responseData => {
    const data = ACC.sanitizer.sanitizeHtmlDeeply(responseData);
    const filteredData = $(data)
      .find('.returns-exchanges-container')
      .html();
    $('.returns-exchanges-container').html(filteredData);
  });
}

$(document).delegate('.order-history', 'click', function() {
  const targetUrl = ACC.config.encodedContextPath + '/my-account-home/orders';
  window.location.replace(targetUrl);
});

$(document).delegate(
  '.returns-exchanges-container .pagination__link',
  'click',
  function(e) {
    e.preventDefault();
    const page = $(this).text();
    const pageValue = parseInt(page) - 1;
    window.localStorage.setItem('pageValue', pageValue);
    updatePaginationData(pageValue);
  }
);

$(document).delegate(
  '.return-mobile-pagination .pagination__link',
  'click',
  function(e) {
    e.preventDefault();
    const page = $(this).text();
    const pageValue = parseInt(page) - 1;
    window.localStorage.setItem('pageValue', pageValue);
    updatePaginationData(pageValue);
  }
);

$(document).delegate(
  '.returns-exchanges-pagination-section .pagination__previous,.returns-exchanges-pagination-section .pagination__next',
  'click',
  function(e) {
    e.preventDefault();
    const eventTarget = $(this).attr('class');
    const parentTarget = $(this)
      .parent()
      .attr('href');
    const page = $('#pageId').val();
    if (parentTarget == undefined) {
      e.stopPropagation();
      return false;
    } else {
      if (eventTarget.includes('pagination__previous')) {
        const pageValue = parseInt(page) - 1;
        window.localStorage.setItem('pageValue', pageValue);
        updatePaginationData(pageValue);
      }
      if (eventTarget.includes('pagination__next')) {
        const pageValue = parseInt(page) + 1;
        window.localStorage.setItem('pageValue', pageValue);
        updatePaginationData(pageValue);
      }
    }
  }
);

$(document).delegate(
  '.return-mobile-pagination .pagination__previous,.return-mobile-pagination .pagination__next',
  'click',
  function(e) {
    e.preventDefault();
    const eventTarget = $(this).attr('class');
    const parentTarget = $(this)
      .parent()
      .attr('href');
    const page = $('#pageId').val();
    if (parentTarget == undefined) {
      e.stopPropagation();
      return false;
    } else {
      if (eventTarget.includes('pagination__previous')) {
        const pageValue = parseInt(page) - 1;
        window.localStorage.setItem('pageValue', pageValue);
        updatePaginationData(pageValue);
      }
      if (eventTarget.includes('pagination__next')) {
        const pageValue = parseInt(page) + 1;
        window.localStorage.setItem('pageValue', pageValue);
        updatePaginationData(pageValue);
      }
    }
  }
);

$(document).delegate(
  '.returns-exchanges-bottom-pagination .pagination__previous,.returns-exchanges-bottom-pagination .pagination__next',
  'click',
  function(e) {
    e.preventDefault();
    const parentTarget = $(this)
      .parent()
      .attr('href');
    const eventTarget = $(this).attr('class');
    const page = $('#pageId').val();
    if (parentTarget == undefined) {
      e.stopPropagation();
      return false;
    } else {
      if (eventTarget.includes('pagination__previous')) {
        const pageValue = parseInt(page) - 1;
        window.localStorage.setItem('pageValue', pageValue);
        updatePaginationData(pageValue);
      }
      if (eventTarget.includes('pagination__next')) {
        const pageValue = parseInt(page) + 1;
        window.localStorage.setItem('pageValue', pageValue);
        updatePaginationData(pageValue);
      }
    }
  }
);

function addClassOnNavItem() {
  let windowUrl = window.location.href;
  if (windowUrl.includes('returns')) {
    $('.accNavComponent__child-wrap #TrackOrder').addClass('highlight');
    $('.accNavComponent__child-wrap #TrackOrder').attr('class', 'highlight');
  } else {
    $('.accNavComponent__child-wrap #TrackOrder').removeClass('highlight');
  }
}
function exchangeOrder() {
  for (let i = 0; i < selectedOrdercheck.length; i++) {
    if (
      selectedOrdercheck[i].value !== 0 &&
      selectedOrdercheck[i].value !== '' &&
      selectedOrdercheck[i].value !== null
    ) {
      $(selectedOrderRowClass)[i].parentNode.classList.add('returnedOrder');
    }
  }
  if ($(returnedOrderClass).length) {
    let docPos = $(orderHistoryReturnExchangeClass).offset().top;
    let divPos = $(returnedOrdereClass).offset().top;
    let scrollPos = divPos - docPos;
    $(window).scrollTop(scrollPos);
  }
}

$(document).ready(function() {
  addClassOnNavItem();
  exchangeOrder();
});
